export type AxisConfig = number[]

export const defaultAxisConfig: AxisConfig = Array(6).fill(2 * Math.PI)
